import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";

const ProfessionalSkills = ({ newdata, setNewdata }) => {
  // Ensure array exists
  const profesionalskils = newdata.profesionalskils || [];

  /* ================= HANDLE CHANGE ================= */
  const handleChange = (e, index) => {
    const updated = [...profesionalskils];
    updated[index] = e.target.value;
    setNewdata(prev => ({
      ...prev,
      profesionalskils: updated
    }));
  };

  /* ================= ADD SKILL ================= */
  const addSkill = () => {
    setNewdata(prev => ({
      ...prev,
      profesionalskils: [...profesionalskils, ""]
    }));
  };

  /* ================= REMOVE SKILL ================= */
  const removeSkill = index => {
    setNewdata(prev => ({
      ...prev,
      profesionalskils: profesionalskils.filter((_, i) => i !== index)
    }));
  };

  return (
    <div className="px-2">
      <Row>
        {profesionalskils.map((skill, index) => (
          <Col md={4} className="mb-3" key={index}>
            <Form.Label className="custm-lble">
              Skill {index + 1}
            </Form.Label>

            <Form.Control
              type="text"
              placeholder="Enter skill"
              value={skill}
              onChange={e => handleChange(e, index)}
              className="labelText"
            />

            {index !== 0 && (
              <div
                className="d-flex align-items-center cursor_P mt-1"
                onClick={() => removeSkill(index)}
              >
                <DeleteIcon className="color-red" />
                <p className="color-remove-red mb-0 ms-1">Remove</p>
              </div>
            )}
          </Col>
        ))}
      </Row>

      <div className="mb-3" onClick={addSkill}>
        <p className="color-text cursor_P">
          <AddCircleIcon style={{ fontSize: "large" }} /> Add More
        </p>
      </div>
    </div>
  );
};

export default ProfessionalSkills;
